<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Debit Order Report</span>
        </div>
    </div>
    <div class="card">
        <div class="row">
            <div class="col-md-4 my-3 d-flex flex-column align-items-center justify-content-center">
                <div class="card_onceoff"  (click)="OpenDialog('SendOverEmail')" style="cursor:pointer;">
                    <img src="../../../../assets/Home-Connect/images/Combined_Billing1.png" class="my-2" >
                    <h5>Combined Billing</h5>
                </div>
            </div>
            <div class="col-md-4 my-3 d-flex flex-column align-items-center justify-content-center"  >
                <div class="card_onceoff" (click)="OpenDialog('GenDebitOrderBatch')" style="cursor:pointer;">
                    <img src="../../../../assets/Home-Connect/images/Debit_Order_Batch1.png" class="my-2" >
                    <h5>Debit Order Batch</h5>
                </div>
            </div>
            <div class="col-md-4 my-3 d-flex flex-column align-items-center justify-content-center">
                <div class="card_onceoff" (click)="OpenDialog('uploadExcelFile')" style="cursor:pointer;">
                    <img src="../../../../assets/Home-Connect/images/Debit_Order_Batch_upload1.png" class="my-2" >
                    <h5>Upload Debit Order</h5>
                </div>
            </div>
        </div>
    </div>
</div>
